import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useFormAutosave } from 'shared_DEPRECATED/hooks';

import {
  useEditGoalMutation__DEPRECATED,
  IGoal__DEPRECATED,
  IGoal,
} from 'features/goal';

type TGoalDeepDiveFormWrapper = {
  goal: IGoal__DEPRECATED | IGoal;
  children: React.ReactNode;
};

export const GoalDeepDiveFormWrapper = ({
  children,
  goal,
}: TGoalDeepDiveFormWrapper) => {
  const formMethods = useForm<IGoal__DEPRECATED | IGoal>({
    values: { ...goal },
  });

  const { mutateAsync } = useEditGoalMutation__DEPRECATED({
    goalId: goal.goalId,
    modifiedColumnId: goal.columnId,
  });

  useFormAutosave({
    formMethods,
    onMutate: mutateAsync,
    storageKey: `goalId-${goal.goalId}`,
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};
